module.exports = __webpack_public_path__ + "images/emoji/love_letter.81296f1dccaefeac445c.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/love_letter.png
// module id = d+zZ
// module chunks = 14